import { FC, useState } from "react";
import { MoreVertical, Download } from "react-feather";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";
import { Nav, NavLink } from "../../Common/Nav/nav";
import { StyledToolbar } from "./style";

type Props = {
  hasAttachments: boolean;
  onDownloadAttachments: () => void;
};

const ToolbarIcons: FC<Props> = ({ hasAttachments, onDownloadAttachments }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const handleNav = () => {
    setShow((prev) => !prev);
  };
  return (
    <StyledToolbar $show={show}>
      {hasAttachments && (
        <Nav customStyle="icon">
          <NavLink
            path="#"
            data-for="tooltip-download-attachments"
            data-tip={t("components.sharepoint.downloadAttachments")}
            onClick={(e: any) => {
              e.preventDefault();
              onDownloadAttachments();
            }}
          >
            <Download />
          </NavLink>
          <ReactTooltip
            place="bottom"
            effect="solid"
            id="tooltip-download-attachments"
          />
        </Nav>
      )}
      <button type="button" className="option-btn" onClick={handleNav}>
        <MoreVertical />
      </button>
    </StyledToolbar>
  );
};

export default ToolbarIcons;
